import { apiFetch } from "../client";

export function getCopturePrices() {
  return apiFetch("/copture/prices/", {
    method: "GET",
  });
}

export function getDroneCouponDiscount({
  refs,
  package_id,
  forest_management_plan_id,
  coupon_code,
}) {
  return apiFetch("/copture/coupon-discount/", {
    method: "POST",
    body: JSON.stringify({
      refs,
      package_id,
      forest_management_plan_id,
      coupon_code,
    }),
  });
}
